import { gql } from "@apollo/client";

export const QueryGeneratorByColumns = (columns = [], parentName) => {
  console.log(columns, parentName);
  // let temp = "";
  // temp = ` ${parentName} {
  //   ${columns.join(" ")}
  // } `;

  const query = gql`query { 
    ${temp} 
   }`;

  return query;
};

export const Get_Test_Leads = gql`
  query {
    lead {
      id
      firstName
      lastName
      email
      createdOn
      salutation
      designation
    }
  }
`;
export const Get_Test_Leads_2 = gql`
  query {
    lead {
      id
      firstName
      lastName
    }
  }
`;
export const Get_Leads = gql`
  query LeadsOffSetPagination($skip: Int, $take: Int) {
    leadsOffSetPagination(skip: $skip, take: $take) {
      totalCount
      items {
        id
        firstName
        lastName
        email
        countryCode
        countryISOCode
        phone
        forcastedAmount
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const Get_Lead_Logs = gql`
  query activityLog($aggregateId: String!) {
    activityLog(aggregateId: $aggregateId) {
      id
      userId
      activity
      dataJson
    }
  }
`;

// phone
// leadNotes {
//   note
//   createdOn
// }
// leadAttachments {
//   name
// }

// list queries

export const Get_leads_By_List_Id = gql`
  query GetLeadsListById(
    $skip: Int
    $take: Int
    $where: ListLeadFilterInput
    $order: [ListLeadSortInput!]
  ) {
    listLeads(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        listId
        leadId
        firstName
        lastName
        email
        phone
        optIn
      }
      totalCount
    }
  }
`;
export const Get_leads_By_Expression = gql`
  query GetLeadsByExpression(
    $skip: Int
    $take: Int
    $expressions: SearchExpressionInput
    $where: ListLeadFilterInput
    $order: [ListLeadSortInput!]
  ) {
    listLeadsCriteria(
      skip: $skip
      take: $take
      expressions: $expressions
      order: $order
      where: $where
    ) {
      items {
        leadId
        firstName
        lastName
        email
        phone
      }
      totalCount
    }
  }
`;
export const Get_leads_By_Expression_Total_Count = gql`
  query GetLeadsByExpression(
    $skip: Int
    $take: Int
    $expressions: SearchExpressionInput
    $where: ListLeadFilterInput
    $order: [ListLeadSortInput!]
  ) {
    listLeadsCriteria(
      skip: $skip
      take: $take
      expressions: $expressions
      order: $order
      where: $where
    ) {
      totalCount
    }
  }
`;

export const Get_Leads_By_Removed_Ids = gql`
  query GetLeadsByIds(
    $skip: Int
    $take: Int
    $where: LeadFilterInput!
    $order: [LeadSortInput!]
  ) {
    leads(where: $where, skip: $skip, take: $take, order: $order) {
      totalCount
      items {
        id
        firstName
        lastName
        email
        phone
      }
    }
  }
`;
export const Get_Leads_By_Removed_Ids_Total_Count = gql`
  query GetLeadsByIds(
    $skip: Int
    $take: Int
    $where: LeadFilterInput!
    $order: [LeadSortInput!]
  ) {
    leads(where: $where, skip: $skip, take: $take, order: $order) {
      totalCount
    }
  }
`;

export const Get_Countries = gql`
  query GetCountries(
    $where: CountriesFilterInput
    $order: [CountriesSortInput!]
  ) {
    countries(where: $where, order: $order) {
      countryId
      countryName
      isocode
      isActive
      createdOn
    }
  }
`;
export const Get_States = gql`
  query GetStates(
    $where: StatesProvincesFilterInput
    $order: [StatesProvincesSortInput!]
  ) {
    statesProvinces(where: $where, order: $order) {
      stateProvinceId
      countryId
      stateProvinceName
      code
      type
      isActive
      createdOn
    }
  }
`;

export const Get_Lead_Origin_Types = gql`
  {
    leadOriginType {
      items {
        id
        value
      }
    }
  }
`;

export const Get_Representatives_Name = gql`
  query VoiceRepresentativeNames {
    voiceCallsAgentNames {
      representativeName
    }
  }
`;
